/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EncounterWriteResult } from './EncounterWriteResult';
import {
    EncounterWriteResultFromJSON,
    EncounterWriteResultFromJSONTyped,
    EncounterWriteResultToJSON,
    EncounterWriteResultToJSONTyped,
} from './EncounterWriteResult';

/**
 * 
 * @export
 * @interface CorrectEncounter200Response
 */
export interface CorrectEncounter200Response {
    /**
     * 
     */
    data?: EncounterWriteResult;
}

/**
 * Check if a given object implements the CorrectEncounter200Response interface.
 */
export function instanceOfCorrectEncounter200Response(value: object): value is CorrectEncounter200Response {
    return true;
}

export function CorrectEncounter200ResponseFromJSON(json: any): CorrectEncounter200Response {
    return CorrectEncounter200ResponseFromJSONTyped(json, false);
}

export function CorrectEncounter200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectEncounter200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : EncounterWriteResultFromJSON(json['data']),
    };
}

export function CorrectEncounter200ResponseToJSON(json: any): CorrectEncounter200Response {
    return CorrectEncounter200ResponseToJSONTyped(json, false);
}

export function CorrectEncounter200ResponseToJSONTyped(value?: CorrectEncounter200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EncounterWriteResultToJSON(value['data']),
    };
}

